import { domainOptions } from 'config/filterTypes';
import { getItemFromLocalStorage } from 'utils/helpers';

const SCREENER_REGION = 'SCREENER/SCREENER_REGION';
const SELECTED_CLASS = 'SCREENER/SELECTED_CLASS';
const SCREENER_DOMAIN = 'SCREENER/SCREENER_DOMAIN';
const IS_SCREENER_FILTER_ACTIVE = 'SCREENER/IS_SCREENER_FILTER_ACTIVE';
const IS_SCREENER_TIME_RANGE = 'SCREENER/IS_SCREENER_TIME_RANGE';

export const setScreenerRegion = screenerRegion => ({
  type: SCREENER_REGION,
  screenerRegion,
});
export const setSelectedClass = sclectedClass => ({
  type: SELECTED_CLASS,
  sclectedClass,
});
export const setScreenerDomain = screenerDomain => ({
  type: SCREENER_DOMAIN,
  screenerDomain,
});
export const setIsScreenerFilterActive = isScreenerFilterActive => ({
  type: IS_SCREENER_FILTER_ACTIVE,
  isScreenerFilterActive,
});
export const setIsScreenerTimeRange = isScreenerTimeRange => ({
  type: IS_SCREENER_TIME_RANGE,
  isScreenerTimeRange,
});

const getDefaultState = () => {
  const screenerSettings = getItemFromLocalStorage('screenerSetting', {});
  const screenerDomain = screenerSettings['screenerDomain'];
  const isScreenerTimeRange = screenerSettings['isScreenerTimeRange'];

  return {
    screenerRegion: null,
    sclectedClass: null,
    screenerDomain: screenerDomain || domainOptions[0].key,
    isScreenerFilterActive: false,
    isScreenerTimeRange: isScreenerTimeRange || true,
  };
};

export default function reducer(
  state = {
    ...getDefaultState(),
  },
  action
) {
  switch (action.type) {
    case SCREENER_REGION:
      return { ...state, screenerRegion: action.screenerRegion };
    case SELECTED_CLASS:
      return { ...state, sclectedClass: action.sclectedClass };
    case SCREENER_DOMAIN:
      return { ...state, screenerDomain: action.screenerDomain };
    case IS_SCREENER_FILTER_ACTIVE:
      return { ...state, isScreenerFilterActive: action.isScreenerFilterActive };
    case IS_SCREENER_TIME_RANGE:
      return { ...state, isScreenerTimeRange: action.isScreenerTimeRange };
    default:
      break;
  }
  return state;
}
